import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairRegistrationSponsorOrHostModalContainerLoadable =
  clientOnlyLazy({
    loader: () =>
      import(
        /* webpackChunkName: "StaffGradFairRegistrationSponsorOrHostModalContainer" */
        './StaffGradFairRegistrationSponsorOrHostModalContainer.dynamic'
      ),
    loading: LoadingModal,
  });
